export interface PdfStatusResponse {  id?: string;  name?: string;  links?: Links[]; }

export interface Links  {  type?: LINKTYPE;  href?: string; }

export enum LINKTYPE {  STATE = 'STATE',  DOCUMENT = 'DOCUMENT' }
